module.exports = __webpack_public_path__ + "img/dostavka-mob.2a7fbc6d.png";